import React from 'react';
import { OTPInput, SlotProps } from 'input-otp';

import './OtpInput.less';

export interface OtpInputProps {
  value?: string;
  onChange?: (value: string) => void;
  onComplete?: (value: string) => void;
  maxLength?: number;
  autoFocus?: boolean;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
  containerClassName?: string;
  'aria-label'?: string;
  'aria-labelledby'?: string;
}

const OtpInput = ({
  value,
  onChange,
  onComplete,
  maxLength = 6,
  autoFocus = false,
  placeholder = '–',
  disabled = false,
  className = '',
  containerClassName = '',
  'aria-label': ariaLabel,
  'aria-labelledby': ariaLabelledBy,
}: OtpInputProps) => {
  const Slot = (slotProps: SlotProps) => (
    <div
      className={`otp-input__slot ${
        slotProps.isActive ? 'otp-input__slot--active' : ''
      }`}
    >
      <span className="otp-input__char">
        {(slotProps.isActive && slotProps.char == null
          ? ''
          : slotProps.char ?? slotProps.placeholderChar ?? placeholder
        ).toUpperCase()}
      </span>
      {slotProps.hasFakeCaret ? <span className="otp-input__caret" /> : null}
    </div>
  );

  const content = (
    <OTPInput
      maxLength={maxLength}
      value={value}
      onChange={(v) => onChange?.(v.toUpperCase())}
      onComplete={(v) => onComplete?.(v.toUpperCase())}
      autoFocus={autoFocus}
      disabled={disabled}
      containerClassName={`otp-input ${containerClassName}`.trim()}
      className={className}
      render={({ slots }) => (
        <div className="otp-input__group">
          {slots.map((slot, idx) => (
            <Slot key={idx} {...slot} />
          ))}
        </div>
      )}
    />
  );

  if (ariaLabel || ariaLabelledBy) {
    return (
      <div
        role="group"
        aria-label={ariaLabel}
        aria-labelledby={ariaLabelledBy}
        className="otp-input__wrapper"
      >
        {content}
      </div>
    );
  }

  return content;
};

export default OtpInput;
